export default __webpack_public_path__ + "static/media/click-sound.9c1ee9ca.mp3";